export const adminRu = {
  // демонстрационная строка каркаса; массовый перевод admin-ui — вне scope
  languageLabel: 'Язык',
};

export type AdminBundle = typeof adminRu;
